import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Box, Grid, Stack, Typography } from "@mui/material"
import HelpIcon from '@mui/icons-material/Help';

import MainContainer from "../../components/Container/MainContainer"
import BlockContainer from "../../components/Container/BlockContainer"
import AppContentHeader from '../../components/AppContentHeader';
import BaseImage from "../../components/BaseImage";
// import BaseAccordion from "../../components/BaseAccordion";

import IconApple from "../../assets/images/reports-icons/Apple.svg";

const NutritionSingleFood = () => {
  const { name } = useParams()
  const reports = useSelector(state => state.patientReports)
  const nutritionData = useMemo(() => reports.find(item => item.name === 'Nutrition'), [reports])
  const functionalFoods = useMemo(() => nutritionData?.data?.['Functional Foods'], [nutritionData])

  const functionalFoodDetail = useMemo(() => {
    if (functionalFoods)
      return Object.entries(functionalFoods)?.[name]
    else
      return null
  }, [functionalFoods, name])

  return (
    <MainContainer
      sx={{
        padding: 0,
        borderRadius: 0,
        overflowX: 'hidden',
        background: "linear-gradient(180deg, #F6F9FC 0%, #C6E7FF 100%)",
      }}
    >
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <Box className='content-header-wave'></Box>
        <BlockContainer
          sx={{
            position: 'relative',
            padding: '16px 20px',
            zIndex: 10,
            mt: '-90px'
          }}
        >
          <AppContentHeader backLabel='Reports' pdfDownloadUrl={nutritionData.pdfUrl}/>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'start',
              padding: '50px 0 38px',
              position: 'relative',
              mt: '50px'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography variant="h1">
                {name}
              </Typography>
            </Box>
            <BaseImage 
              src={IconApple}
              sx={{
                width: '160px',
                height: '160px',
                position: 'absolute',
                right: -20,
                top: 5,
                opacity: 0.4
              }}
            />
          </Box>
        </BlockContainer>
        <BlockContainer
          sx={{
            px: '20px',
            mb: '20px',
            position: 'relative',
            zIndex: 10
          }}
        >
          <Grid container spacing={'16px'}>
            <Grid item xs={12} mmd={6}>
              <Box
                sx={{
                  padding: '16px',
                  borderRadius: '8px',
                  bgcolor: 'white'
                }}
              >
                <Typography variant='body' color='primary.darkGray'>
                  Vitamins
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end'
                  }}
                >
                  <Typography variant='subText' color='primary.darkGray'>Percent risk alleles</Typography>
                  <HelpIcon
                    sx={{
                      color: 'primary.mediumGray',
                      fontSize: '20px',
                    }}
                  />
                </Box>
                <Stack direction={'column'} spacing={'4px'}>
                  {functionalFoodDetail && Object.entries(functionalFoodDetail[1]).map((item => (
                    <Box
                      key={item[0]}
                      sx={{
                        borderRadius: '4px',
                        borderLeft: '4px solid',
                        borderColor: 'primary.mediumBlue',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '8px 16px',
                        boxShadow: '0px 2px 10px 0px #5B87EF33'
                      }}
                    >
                      <Typography variant='body' color='primary.darkGray'>{item[0]}</Typography>
                      <Box
                        sx={{
                          borderRadius: '4px',
                          padding: '2px 16px',
                          bgcolor: 'primary.darkGreen'
                        }}
                      >
                        <Typography variant='body' color='white'>{`${(item[1] * 100).toFixed(0)}%`}</Typography>
                      </Box>
                    </Box>
                  )))}
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </BlockContainer>
      </Box>
    </MainContainer>
  )
}

export default NutritionSingleFood